import React, { FC, useContext } from 'react';

import { IdeaFormContext } from 'buyside/components/presentation/IdeaForm/ideaForm';
import CatalystsField from 'buyside/components/presentation/IdeaForm/Details/DetailsFields/catalystsField';
import PairTradeFields from 'buyside/components/presentation/IdeaForm/Details/DetailsFields/pairTradeFields';
import ResearchFormWizardSection from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';
import SelectField from 'buyside/components/presentation/Fields/selectField';

import { IDEA_SUBMISSION_TIMEFRAMES } from 'buyside/util/researchSubmission';
import { labelize } from 'buyside/util/arrayHelper';

import styles from './detailsStyles.scss';

const { investmentSituations, targetAllocation } = require('buyside/util/constantsFromRails.json');

const Details: FC = () => {
  const { isDraft } = useContext(IdeaFormContext);

  return (
    <ResearchFormWizardSection title="Position Details">
      <PairTradeFields isDraft={isDraft} />
      <div className={styles.detailsFields}>
        <SelectField
          disabled={!isDraft}
          label="Target Allocation"
          name="portfolioPercentage"
          options={labelize(targetAllocation)}
        />
        <SelectField
          disabled={!isDraft}
          label="Timeframe"
          name="timeframe"
          options={labelize(IDEA_SUBMISSION_TIMEFRAMES, true)}
        />
        <SelectField
          disabled={!isDraft}
          label="Situation"
          name="situation"
          options={labelize(investmentSituations, true)}
        />
        <CatalystsField isDisabled={!isDraft} name="catalystNames" />
      </div>
    </ResearchFormWizardSection>
  );
};

export default Details;
